import React from 'react';

// A generated initials avatar — a colored circle with 1–2 letters derived from the name. No data
// or network needed; the color is deterministic per name so a given author always looks the same.
const COLORS = [
  '#4f9d69',
  '#3f7cac',
  '#b3679b',
  '#c9803a',
  '#5b8a72',
  '#7a6ff0',
  '#c0563b',
  '#3a8fb7',
  '#8a7a3a',
  '#9b5bb0',
];

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function colorOf(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

export default function Avatar(props: { name: string; size?: number }): React.ReactNode {
  const { name, size = 28 } = props;
  const label = name && name.trim() !== '' ? name : 'unknown';
  return (
    <span
      className="cm-avatar"
      title={label}
      style={{
        width: size,
        height: size,
        background: colorOf(label),
        fontSize: Math.round(size * 0.4),
      }}
      aria-hidden="true"
    >
      {initialsOf(label)}
    </span>
  );
}
